import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Scoreboard from './Scoreboard';
import { ScoreboardProvider } from './context/ScoreboardContext';
import { MusicProvider } from './context/MusicContext';
import { LanguageProvider } from './context/LanguageContext';
import { DashboardLanguageProvider } from './context/DashboardLanguageContext';
import { PageLanguageProvider, usePageLanguage } from './context/PageLanguageContext';

import useGoogleAnalytics from './hooks/useGoogleAnalytics';
import './App.css';
import ScoreboardLive from './ScoreboardLive';
import HeaderSection from './content/HeaderSection';
import HeroSection from './content/HeroSection';
import FeatureSection from './content/FeatureSection';
import EditionsSection from './content/EditionsSection';
import BenefitSection from './content/BenefitSection';
import CommunitySection from './content/CommunitySection';
import FooterSection from './content/FooterSection';
import Manual from './pages/Manual';
import VideoPlayer from './VideoPlayer';
import VideoGuides from './pages/VideoGuides';
import Changelog from './pages/Changelog';
import Desktop from './pages/Desktop';
import Pricing from './pages/Pricing';

function HomePage() {
  useGoogleAnalytics();
  const { pageLanguage, setPageLanguage } = usePageLanguage();
  return (
    <div>
      <HeaderSection lang={pageLanguage} setLang={setPageLanguage} />
      <HeroSection lang={pageLanguage} />
      {/* What a club gets out of it, argued from the desktop edition — the "why" before the "what". */}
      <BenefitSection lang={pageLanguage} />
      <FeatureSection lang={pageLanguage} />
      <CommunitySection lang={pageLanguage} />
      {/* Which version you need comes LAST: decide whether you want it, then which one. */}
      <EditionsSection lang={pageLanguage} />
      <FooterSection lang={pageLanguage} />
    </div>
  );
}

function App() {
  return (
    <Router>
      <PageLanguageProvider>
        <LanguageProvider>
          <DashboardLanguageProvider>
            <ScoreboardProvider>
              <MusicProvider>
                <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/control" element={<Scoreboard />} />
                <Route path="/liveview" element={<ScoreboardLive />} />
                <Route path="/manual" element={<Manual />} />
                <Route path="/videos" element={<VideoGuides />} />
                <Route path="/videoplayer" element={<VideoPlayer />} />
                <Route path="/changelog" element={<Changelog />} />
                <Route path="/desktop" element={<Desktop />} />
                <Route path="/preise" element={<Pricing />} />
                {/* English visitors reach for /pricing; same page. */}
                <Route path="/pricing" element={<Pricing />} />
                </Routes>
              </MusicProvider>
            </ScoreboardProvider>
          </DashboardLanguageProvider>
        </LanguageProvider>
      </PageLanguageProvider>
    </Router>
  );
}

export default App;
